import BuyStack23 from './BuyStack23'
import CtaButtonGroup23 from './CtaButtonGroup23'
import '@/components/social-proof/SocialProofRegister'

if (!customElements.get('cta-button-group-23')) {
  customElements.define('cta-button-group-23', CtaButtonGroup23)
}

if (!customElements.get('buy-stack-23')) {
  customElements.define('buy-stack-23', BuyStack23)
}
